// Wieviele Spalten die Playmat tatsächlich rendert. Die Spaltenzahl aus den Einstellungen
// ist ein Wunsch, keine Zusage: wird die Fläche schmal (offene Katalog-Spalte, kleines
// Fenster), werden Karten sonst unter ihre Mindestbreite gequetscht. Alle Ansichten mit
// spaltenbasierter Kartenbreite rechnen hierüber, damit die Kappung nicht je Ansicht
// auseinanderläuft.

/**
 * Gerenderte Spaltenzahl einer Kartenfläche.
 *
 * Modell der Breitenrechnung, die alle Aufrufer teilen:
 *   nutzbar(n) = containerWidth − fixedExtra − (n−1)·gap − n·perColumnExtra
 * Gesucht ist das größte n, für das `nutzbar(n) / n ≥ minCardWidth` gilt — aufgelöst
 * ergibt das den Bruch unten.
 *
 * @param {number} containerWidth — gemessene Breite der Fläche; 0 = noch nicht gemessen,
 *   dann bleibt es beim Wunsch (die Messung kommt einen Frame später)
 * @param {number} columnCount — gewünschte Spaltenzahl (Präferenz), nie überschritten
 * @param {number} minCardWidth — Mindestbreite einer Karte
 * @param {number} gap — Abstand ZWISCHEN zwei Spalten
 * @param {number} [perColumnExtra] — Breite, die jede Spalte zusätzlich zur Karte braucht
 *   (Innenabstand/Rahmen eines Stapels)
 * @param {number} [fixedExtra] — Breite, die einmalig abgeht (Rand der Ansicht, Rahmen des
 *   Kategorie-Kastens, Sicherheitspuffer)
 * @returns {number} Spaltenzahl, mindestens 1
 */
export function fittingColumnCount({
  containerWidth,
  columnCount,
  minCardWidth,
  gap,
  perColumnExtra = 0,
  fixedExtra = 0,
}) {
  if (!containerWidth) return columnCount;
  const passen = Math.floor((containerWidth - fixedExtra + gap) / (minCardWidth + gap + perColumnExtra));
  return Math.max(1, Math.min(columnCount, passen));
}
